(() => {
  class ForgotPassword {
    constructor($scope, toastr, Auth, Notifications) {
      'ngInject';

      Object.assign(this, {
        $scope,
        Notifications,
        Auth,
        toastr
      });
    }

    sendEmail() {
      this.Auth.sendResetPasswordEmail(this.email).then(() => {
        this.onSendSuccess();
      }).catch(err => {
        if (err.status === 404) {
          this.onSendSuccess();
        } else {
          this.toastr.error(this.Notifications.auth.sendResetEmailFailed);
        }
      });
    }

    onSendSuccess() {
      this.toastr.success(this.Notifications.auth.sendResetEmailSuccess);
      this.email = '';
      this.$scope.forgotForm.$setPristine();
      this.$scope.forgotForm.$setUntouched();
    }

  }

  ForgotPassword.$inject = ["$scope", "toastr", "Auth", "Notifications"];
  angular.module('pims').controller('ForgotPasswordController', ForgotPassword);
})();